import { useUnit } from 'effector-react';
import { useChanges } from '@nx-frontend/shared/hooks/useChangeEvents';
import { $theme } from '@nx-frontend/shared/store/portal-theme';
import { PortalThemeConfigPartial } from '@nx-frontend/shared/types';
import { ChangeEvent, ChangeEventBase, ChangeEventType, ChangeEventMeta } from '@nx-frontend/shared/types';
import { patchObject } from '@nx-frontend/shared/utils';

type ThemeChangesPayload = Pick<ChangeEventBase, 'squashId' | 'collectId' | 'batchId'> & {
  partialValue: PortalThemeConfigPartial;
  patch?: boolean;
};

export const useThemeChanges = (): ((payload: ThemeChangesPayload) => ChangeEvent) => {
  const [{ theme: oldValue }] = useUnit([$theme]);
  const setChanges = useChanges();
  return ({ partialValue, batchId, squashId, collectId, patch = true }) => {
    const newValue = patch ? patchObject(oldValue, partialValue, true) : partialValue;
    const changeEvent: ChangeEvent = {
      type: ChangeEventType.UPDATE_THEME_SETTINGS,
      oldValue,
      newValue,
      meta: {
        ...(batchId != null ? { batchId } : {}),
        ...(squashId != null ? { squashId } : {}),
        ...(collectId != null ? { collectId } : {}),
      } as ChangeEventMeta,
    };

    return setChanges(changeEvent);
  };
};
